import React, { useState, useEffect, useRef } from "react";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import { getDiscountDetail } from "../../services/discountService";
import moment from "moment";

const ViewDiscountPageNew = () => {
  const [itemData, setItemData] = useState(null); // State to store user details
  const [loading, setLoading] = useState(true); // State to handle loading
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getDiscountDetail(id);
        const data = res.data.result;
        setItemData(data);
        console.log(data);
      } catch (err) {
        setErrorMessage("Failed to fetch discount detail.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold">Code</label>
                <div>{itemData?.code || "N/A"}</div>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Discount</label>
                <p>{itemData?.discount || "N/A"}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Start Date</label>
                <p>{moment(itemData.startDate).format("DD-MM-YYYY")}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">End Date</label>
                <p>{moment(itemData.endDate).format("DD-MM-YYYY")}</p>
              </div>
              <div className="col-md-2 mb-3">
                {itemData?.type === "host" && (
                  <>
                    <label className="form-label fw-bold mt-2">Host By</label>
                    <p>{itemData?.userId?.fullName || "N/A"}</p>
                  </>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <label className="form-label fw-bold mt-2">Description</label>
              <p>{itemData?.description || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDiscountPageNew;
